import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { Redirect, withRouter } from 'react-router-dom';
import { apiBaseUrls, loginPageFullPath } from '@saucelabs/sl-util-config';

import { operations } from './../ducks/container';
import FormTitle from './../components/FormTitle';
import HelpLinks from './../components/HelpLinks';
import FormWrapper from './../components/FormWrapper';
import ResetPasswordForm from './../components/ResetPasswordForm';

const ResetPasswordContainer = ({ resetPassword, state }) => {
  if (!state || !state.verifier) {
    return (
      <Redirect
        to={{
          pathname: '/send-password-reset',
          state: {
            error: 'Verification failed. ' +
              'Please try again or email <a href="mailto:help@saucelabs.com">' +
              'help@saucelabs.com</a> if the issue persists.',
          },
        }}
      />
    );
  }

  return (
    <FormWrapper>
      <Helmet>
        <title>Reset Password</title>
      </Helmet>
      <FormTitle>Forgot Your Password?</FormTitle>
      <ResetPasswordForm
        resetPassword={resetPassword}
        verifier={state.verifier}
      />
      <HelpLinks>
        <div>
          {'New to Sauce Labs? '}
          <a href={apiBaseUrls.signup}>
            Create an Account
          </a>
        </div>
        <div>
          {'Remember your Password? '}
          <a href={loginPageFullPath}>
            Login here
          </a>
        </div>
      </HelpLinks>
    </FormWrapper>
  );
};

const mapStateToProps = (store, { location: { state } }) => ({
  state,
});

const mapDispatchToProps = {
  resetPassword: operations.resetPassword,
};

ResetPasswordContainer.propTypes = {
  resetPassword: PropTypes.func.isRequired,
  state: PropTypes.object,
};

ResetPasswordContainer.defaultProps = {
  state: null,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ResetPasswordContainer),
);
export { ResetPasswordContainer, mapDispatchToProps };
